import React, { useState } from 'react';
import { Input, Popconfirm } from 'antd';

interface FeedbackPopconfirmProps {
  /**
   * The button content to be wrapped by the Popconfirm
   */
  children: React.ReactNode;
  /**
   * Whether the Popconfirm is currently visible
   */
  visible: boolean;
  /**
   * Callback when the Popconfirm visibility changes
   */
  onVisibleChange: (visible: boolean) => void;
  /**
   * Callback when user confirms the feedback
   */
  onConfirm: (textFeedback: string) => Promise<void> | void;
  /**
   * Callback when user cancels/skips the feedback
   */
  onCancel: () => Promise<void> | void;
}

/**
 * A reusable Popconfirm component for collecting user feedback with optional text input
 * @param root0
 * @param root0.children
 * @param root0.visible
 * @param root0.onVisibleChange
 * @param root0.onConfirm
 * @param root0.onCancel
 */
const FeedbackPopconfirm: React.FC<FeedbackPopconfirmProps> = ({
  children,
  visible,
  onVisibleChange,
  onConfirm,
  onCancel
}) => {
  const [textFeedback, setTextFeedback] = useState('');

  const handleConfirm = async () => {
    await onConfirm(textFeedback);
    setTextFeedback('');
  };

  const handleCancel = async () => {
    await onCancel();
    setTextFeedback('');
  };

  const handleVisibleChange = (newVisible: boolean) => {
    if (!newVisible) {
      setTextFeedback('');
    }
    onVisibleChange(newVisible);
  };

  return (
    <Popconfirm
      title={
        <div>
          <div className="mb-2">Please provide additional feedback</div>
          <Input.TextArea
            value={textFeedback}
            onChange={(e) => setTextFeedback(e.target.value)}
            rows={4}
            placeholder="Optional: Share your thoughts..."
          />
        </div>
      }
      onConfirm={handleConfirm}
      okText="Submit"
      cancelButtonProps={{ style: { display: 'none' } }}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      overlayStyle={{ zIndex: 100000000000000000 }}
    >
      {children}
    </Popconfirm>
  );
};

export default FeedbackPopconfirm;
